import { CollectionFavoriteStateChannel } from '@tableau/search-microview-communication-channels';

import { CollectionsResourceQuery } from '~src/Collections/ResourceQuery/CollectionsResourceQuery';


export function startListening(): () => void {
    const collectionFavoriteStateChannel = new CollectionFavoriteStateChannel();

    const stopListeningCollectionFavoriteStateChannel = collectionFavoriteStateChannel.listen((request) => {
        return new Promise((resolve, reject) => {
            new CollectionsResourceQuery().getByLuid(request.id)
                .then((collectionInfo) => resolve(collectionInfo.collection.favorite))
                .catch((e) => reject(e));
        });
    });

    return () => {
        stopListeningCollectionFavoriteStateChannel();
    };
}